<template>
    <div class="nothing-wrap" v-show="list.length == 0">
        <img class="nothing" src="~assets/image/list-nothing.png">
    </div>
</template>

<script>
export default {
    props:{
        list:{
            type:Array,
            default:function(){
                return [];
            },
            required:true,
        }
    }
}
</script>

<style lang="less" scoped>
    .nothing-wrap{
        position: relative;
        height:100%;
        .nothing{
            // width:230px;
            position: absolute;
            top:50%;
            left:50%;
            user-select: none;
            transform: translate(-50%,-50%);
        }
    }
</style>





// WEBPACK FOOTER //
// noData.vue?78705c75